<template lang="pug">
div
  b-modal(:active="isModalOpened", has-modal-card)
    .modal-card
      .modal-card-head
        p.modal-card-title Edit record
      .modal-card-body
        b-field(label="Title")
          b-input(v-model="title")
        b-field(label="Authors")
          b-input(v-model="authors")
        b-field(label="Publication")
          b-input(v-model="publication")
        b-field(label="Year")
          b-input(v-model="year")
        b-field(label="Website")
          b-input(v-model="website")
        b-field(label="Cited by (number)")
          b-input(v-model="citeNum")
        b-field(label="Link to Citation")
          b-input(v-model="linkToCitation")
        //- b-field(label="APA")
        //-   b-input(type="textarea", v-model="apa")
        //- b-field(label="BibTeX")
        //-   b-input(type="textarea", v-model="bibtex")
      .modal-card-foot
        .container
          .level
            .level-left
              .level-item
                b-button(type="is-primary", @click="uiEditPaper") Update
                b-button(type="is-danger", @click="closeModal") Cancel
            .level-right
              .level-item
                b-button(
                  type="is-danger",
                  icon-left="trash-alt",
                  @click="uiDeletePaper"
                ) Delete record
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  computed: {
    ...mapState("editPaper", {
      isModalOpened: (s) => s.isModalOpened,
      selectedRecord: (s) => s.selectedRecord,
    }),
    ...mapState("collection", {
      selectedCollectionId: (s) => s.selectedCollectionId,
    }),
    title: {
      get() {
        return this.selectedRecord?.title;
      },
      set(v) {
        this.editSelectedRecord({ title: v });
      },
    },
    authors: {
      get() {
        return this.selectedRecord?.authors;
      },
      set(v) {
        this.editSelectedRecord({ authors: v });
      },
    },
    publication: {
      get() {
        return this.selectedRecord?.publication;
      },
      set(v) {
        this.editSelectedRecord({ publication: v });
      },
    },
    year: {
      get() {
        return this.selectedRecord?.year;
      },
      set(v) {
        this.editSelectedRecord({ year: v });
      },
    },
    citeNum: {
      get() {
        return this.selectedRecord?.citeNum;
      },
      set(v) {
        this.editSelectedRecord({ citeNum: v });
      },
    },
    website: {
      get() {
        return this.selectedRecord?.website;
      },
      set(v) {
        this.editSelectedRecord({ website: v });
      },
    },
    apa: {
      get() {
        return this.selectedRecord?.apa;
      },
      set(v) {
        this.editSelectedRecord({ apa: v });
      },
    },
    bibtex: {
      get() {
        return this.selectedRecord?.bibtex;
      },
      set(v) {
        this.editSelectedRecord({ bibtex: v });
      },
    },
    linkToCitation: {
      get() {
        return this.selectedRecord?.linkToCitation;
      },
      set(v) {
        this.editSelectedRecord({ linkToCitation: v });
      },
    },
  },
  methods: {
    ...mapMutations("editPaper", ["closeModal", "editSelectedRecord"]),
    ...mapActions("editPaper", ["editPaper", "deletePaper"]),
    ...mapActions("collection", ["fetchCollectionPapers", "fetchCollections"]),
    async uiEditPaper() {
      const reqBody = {
        paper: this.selectedRecord,
      };
      const resp = await this.editPaper(reqBody);
      if (resp.status === "success") {
        this.openSuccessSnackbar("Record is updated");
        //refetch collection paper
        await this.fetchCollectionPapers({
          collectionId: this.selectedCollectionId,
        });
      } else {
        this.openErrorSnackbar(
          resp.message ?? "Updating record error! Please try again later"
        );
      }
      this.closeModal();
    },
    async uiDeletePaper() {
      const confirmCallback = async () => {
        const reqBody = {
          paperId: this.selectedRecord.id,
        };
        const resp = await this.deletePaper(reqBody);
        if (resp.status === "success") {
          this.openSuccessSnackbar("Record is deleted");
          await this.fetchCollections();
          await this.fetchCollectionPapers({
            collectionId: this.selectedCollectionId,
          });
        } else {
          this.openErrorSnackbar(
            resp.message ?? "Deleting record error! Please try again later"
          );
        }
        this.closeModal();
      };

      this.openDangerConfirmMessageBox(
        "Are you sure to delete this record?",
        confirmCallback
      );
    },
  },
};
</script>